import { render, staticRenderFns } from "./pedido-planificar.vue?vue&type=template&id=3aa4b01a&scoped=true"
import script from "./pedido-planificar.vue?vue&type=script&lang=js"
export * from "./pedido-planificar.vue?vue&type=script&lang=js"
import style1 from "./pedido-planificar.vue?vue&type=style&index=1&id=3aa4b01a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa4b01a",
  null
  
)

export default component.exports